var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_4118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 29.6664L44.5883 25.873C44.8424 25.7461 45.1246 25.6862 45.4083 25.699C45.692 25.7117 45.9677 25.7968 46.2093 25.9461C46.4509 26.0953 46.6504 26.3038 46.7888 26.5518C46.9271 26.7998 46.9998 27.0791 47 27.363V38.6364C46.9998 38.9204 46.9271 39.1996 46.7888 39.4476C46.6504 39.6956 46.4509 39.9041 46.2093 40.0534C45.9677 40.2026 45.692 40.2877 45.4083 40.3005C45.1246 40.3132 44.8424 40.2533 44.5883 40.1264L37 36.333V29.6664Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 26.3333C17 25.4493 17.3512 24.6014 17.9763 23.9763C18.6014 23.3512 19.4493 23 20.3333 23H33.6667C34.5507 23 35.3986 23.3512 36.0237 23.9763C36.6488 24.6014 37 25.4493 37 26.3333V39.6667C37 40.5507 36.6488 41.3986 36.0237 42.0237C35.3986 42.6488 34.5507 43 33.6667 43H20.3333C19.4493 43 18.6014 42.6488 17.9763 42.0237C17.3512 41.3986 17 40.5507 17 39.6667V26.3333Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_4118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.112dac8369caa45c93ee075429747a21.svg";
export { ForwardRef as ReactComponent };